(() => {
 const section = document.querySelector('#device-explained');
 if (!section) return;
 const cards = [...section.querySelectorAll('.mechanism-steps li')];
 const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
 let timer, active = -1, visible = false;
 const stop = () => { clearInterval(timer); timer = null; cards.forEach(c => c.classList.remove('is-current')); };
 const advance = () => { cards.forEach(c => c.classList.remove('is-current')); active = (active + 1) % cards.length; cards[active].classList.add('is-current'); };
 const sync = () => { stop(); if (visible && !document.hidden && !motion.matches) { advance(); timer = setInterval(advance, 1600); } };
 new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible) section.classList.add('has-entered'); sync(); }, {threshold: 0.12}).observe(section);
 document.addEventListener('visibilitychange', sync);
 motion.addEventListener('change', sync);
})();
